import React from 'react';

// Importing all sections used in the homepage
import { Home, About, Counter, Testimonials, Blogs, Services, NewsletterSection, Banner, Team, ProjectSection, Pillars, Prayers, Events, Donations, Sponsors } from '../../sections';


const HomePage = () => {

  return (
    <div className='homepage'>
      <Home /> {/* Home Section */}
      <About /> {/* About Section */}
      <Counter /> {/* Counter Section */}
      <Services /> {/* Services Slider */}
      <Prayers /> {/* Prayer Timings */}
      <ProjectSection /> {/* Project Section */}
      <Banner /> {/* Banner Section */}
      <Events /> {/* Upcoming Events Section */}
      <Pillars /> {/* Pillars of Islam */}
      <Donations /> {/* Donations Slider */}
      <Testimonials /> {/* Testimonials Slider */}
      <Team /> {/* Team Section */}
      <NewsletterSection /> {/* Newsletter subscription Section */}
      <Blogs /> {/* Latest blog posts */}
      <Sponsors /> {/* Sponsors Slider */}
    </div>
  )

}

export default HomePage;